export const getDefaultValues = (wheelDetails) => ({
  WheelWheelTypeID: wheelDetails?.WheelWheelTypeID || '',
  WheelLabel: wheelDetails?.WheelLabel || '',
  WheelDescription: wheelDetails?.WheelDescription || '',
  WheelBackdrop: wheelDetails?.WheelBackdrop || '',
  WheelWaitingHours: wheelDetails?.WheelWaitingHours || '',
  WheelRotateTimes: wheelDetails?.WheelRotateTimes || '',
  WheelFreeChance: wheelDetails?.WheelFreeChance || '',
  WheelCost: wheelDetails?.WheelCost,
  WheelEnable: wheelDetails?.WheelEnable ? 1 : 0,
  WheelRewardCallbackUrl: wheelDetails?.WheelRewardCallbackUrl,
  WheelTransactionAmountTypeID: wheelDetails?.WheelTransactionAmountTypeID || '',
});
